interface OsanoWindow {
  Osano?: { cm?: { showDrawer: (id: string) => void } }
}

/**
 * Opens the Osano cookie-consent drawer. Centralizes the single `window as
 * unknown as OsanoWindow` cast that was previously duplicated across the
 * FooterLegal{Na,Eu,Sp} components.
 */
export const useOsano = () => {
  const showOsano = () => {
    (window as unknown as OsanoWindow).Osano?.cm?.showDrawer('osano-cm-dom-info-dialog-open')
  }

  return { showOsano }
}
